export interface CourseListItem {
  /** 课程名称 */
  courseId?: number;
  /** 课程标题 */
  courseName?: string;
  updateTime?: string;
}
export interface QueryHomeInfoResult {
  /** 年度已完成gmv，分 */
  yearGmv?: number;
  /** 年度已完成推广花费，分 */
  yearCost?: number;
  /** 每月支付金额目标，单位分。按1月、2月。。。12月的顺序 */
  gmvGoalPerMonth?: Array<number>;
  /** 每月推广花费金额目标，单位分。按1月、2月。。。12月的顺序 */
  costGoalPerMonth?: Array<number>;
  /** 月度已完成gmv，分 */
  monthGmv?: number;
  /** 月度已完成推广花费，分 */
  monthCost?: number;
  /** 学院课程 */
  courseList?: Array<CourseListItem>;
}

export interface BrandInfoListItem {
  /** 品牌名称 */
  brandName?: string;
  /** 品牌id */
  brandId?: number;
}

export interface UpdateGoalParams {
  /** 每月目标，单位分。 1月，2月，。。。12月 */
  goalPerMonth: Array<number>;
  /** 1-支付金额目标；2-推广花费目标 */
  type: number;
}

export enum GoalTypeEnums {
  /** 支付金额目标 */
  GMV = "gmv",
  /** 推广花费目标 */
  COST = "cost",
}
